import { getStorageData } from "@/utils/storageUtil";
import { AxiosError } from "axios";

const baseURL = `${process.env.VUE_APP_SERVER_URL}/ProgramasOmint`;

export async function PodeSolicitarProgramaTodaVida(): Promise<{
  podeSolicitar: boolean;
}> {
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/PodeSolicitarProgramaTodaVida`,
      query: {
        vinculo: getStorageData("vinculo", "")
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("PodeSolicitarProgramaTodaVida", error.message);
      return error;
    });
}

export async function SolicitarInclusaoProgramaTodaVida(): Promise<
  | {
      ProtocoloANS: string;
    }
  | AxiosError
> {
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/SolicitarInclusaoProgramaTodaVida`,
      query: {
        vinculo: getStorageData("vinculo", "")
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("SolicitarInclusaoProgramaTodaVida", error.message);
      return error;
    });
}
